import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import "../../styles/global.scss"

import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import 'bootstrap/dist/css/bootstrap.min.css';
// import MenuList from "../components/MenuList"

const IndexPage = () => (
  <Layout title="HWMR - Morning Nourishment">
    <SEO title="The Holy Word for Morning Revival"/>
    <section>
    <div className="container">
    <h2>Semiannual Training June 30 – July 5, 2025</h2>
    <h3>Experiencing, Enjoying, and Expressing Christ (3)</h3> 
    {/*  Start of the Accordion boxes for the weekly verses. 6 weeks a time. 
        Also defaultActiveKey="#" defines which card is automatically opened. */}
    <Accordion defaultActiveKey="36">
      {/*  Daily verses for Week 31  */}
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="31">
           Week 31: The Author (the Captain) of Salvation and the Forerunner Leading Many Sons into Glory by Entering within the Veil and Going outside the Camp 
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="31">
           <Card.Body>
              <ul>
              <li><strong>Day 1</strong></li>
                 <li><strong>Hebrews 2:10-11</strong><br></br>
                 <strong><sup>[10]</sup></strong>For it was fitting for Him, for whom are all things and through whom are all things, in leading many sons into glory, to make the Author of their salvation perfect through sufferings.<br></br>
                 <strong><sup>[11]</sup></strong>For both He who sanctifies and those who are being sanctified are all of One, for which cause He is not ashamed to call them brothers.</li>
                 <li><strong>Luke 24:26</strong> Was it not necessary for the Christ to suffer these things and enter into His glory?</li>
                 <br></br>

              <li><strong>Day 2</strong></li>
                 <li><strong>Colossians 1:27</strong> To whom God willed to make known what are the riches of the glory of this mystery among the Gentiles, which is Christ in you, the hope of glory.</li> 
                 <li><strong>2 Corinthians 4:17</strong> For our momentary lightness of affliction works out for us, more and more surpassingly, an eternal weight of glory.</li>
                 <br></br>

              <li><strong>Day 3</strong></li>
                 <li><strong>Hebrews 13:12</strong> Therefore also Jesus, that He might sanctify the people through His own blood, suffered outside the gate.</li>
                 <li><strong>1 Thessalonians 5:23</strong> And the God of peace Himself sanctify you wholly, and may your spirit and soul and body be preserved complete, without blame, at the coming of our Lord Jesus Christ.</li>
                 <br></br>

              <li><strong>Day 4</strong></li>
                 <li><strong>Hebrews 6:19-20</strong><br></br>
                 <strong><sup>[19]</sup></strong>Which we have as an anchor of the soul, both secure and firm and which enters within the veil,<br></br>
                 <strong><sup>[20]</sup></strong>Where the Forerunner, Jesus, has entered for us, having become forever a High Priest according to the order of Melchizedek.</li>
                 <li><strong>Hebrews 13:13</strong> Let us therefore go forth unto Him outside the camp, bearing His reproach.</li> 
                 <br></br>

              <li><strong>Day 5</strong></li>
                 <li><strong>1 Corinthians 10:6-7</strong><br></br>
                 <strong><sup>[6]</sup></strong>Now these things occurred as examples to us, that we should not be ones who lust after evil things, even as they also lusted.<br></br>
                 <strong><sup>[7]</sup></strong>Neither become idolaters, as some of them did; as it is written, “The people sat down to eat and drink, and stood up to play.”</li>
                 <li><strong>1 John 5:21</strong> Little children, guard yourselves from idols.</li>
                 <br></br>

              <li><strong>Day 6</strong></li>
                 <li><strong>Exodus 33:9</strong> And whenever Moses entered the tent, the pillar of cloud would descend and stay at the entrance of the tent, and Jehovah would speak with Moses.</li>
                 <li><strong>Exodus 33:11</strong> And Jehovah would speak to Moses face to face, just as a man speaks to his companion. And Moses would return to the camp, but his attendant Joshua the son of Nun, a young man, would not depart out of the tent.</li>
                 <li><strong>Exodus 33:14</strong> And He said, My presence shall go with you, and I will give you rest.</li>
              </ul>  
           </Card.Body>
        </Accordion.Collapse>
      </Card>

     {/* Daily verses for Week 32 */}
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="32">
           Week 32: Looking Away unto Jesus, the Author and Perfecter of Our Faith
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="32">
           <Card.Body>
           <ul>
              <li><strong>Day 1</strong></li>
                 <li><strong>Hebrews 12:2</strong> Looking away unto Jesus, the Author and Perfecter of our faith, who for the joy set before Him endured the cross, despising the shame, and has sat down on the right hand of the throne of God.</li>
                 <li><strong>Hebrews 1:3</strong> Who, being the effulgence of His glory and the impress of His substance and upholding and bearing all things by the word of His power, having made purification of sins, sat down on the right hand of the Majesty on high;</li>
                 <br></br>

              <li><strong>Day 2</strong></li>
                 <li><strong>Hebrews 12:1</strong> Therefore let us also, having so great a cloud of witnesses surrounding us, put away every encumbrance and the sin which so easily entangles us and run with endurance the race which is set before us,</li>
                 <li><strong>1 Corinthians 9:24</strong> Do you not know that those who run on a racecourse all run, but one receives the prize? Run in this way, that you may lay hold.</li>
                 <li><strong>2 Thessalonians 3:5</strong> And the Lord direct your hearts into the love of God and into the endurance of Christ.</li>
                 <br></br>

              <li><strong>Day 3</strong></li>
                 <li><strong>2 Peter 1:1</strong> Simon Peter, a slave and apostle of Jesus Christ, to those who have been allotted faith equally precious as ours in the righteousness of our God and Savior, Jesus Christ:</li>
                 <li><strong>Romans 10:17</strong> So faith comes out of hearing, and hearing through the word of Christ.</li>
                 <br></br>

              <li><strong>Day 4</strong></li>
                 <li><strong>Hebrews 11:1</strong> Now faith is the substantiation of things hoped for, the conviction of things not seen.</li>
                 <li><strong>2 Corinthians 4:13</strong> And having the same spirit of faith according to that which is written, “I believed, therefore I spoke,” we also believe, therefore we also speak,</li>
                 <br></br>

              <li><strong>Day 5</strong></li>
                 <li><strong>Hebrews 11:5-6</strong><br></br>
                 <strong><sup>[5]</sup></strong>By faith Enoch was translated so that he should not see death; and he was not found, because God had translated him. For before his translation he obtained the testimony that he had been well pleasing to God.<br></br>
                 <strong><sup>[6]</sup></strong>But without faith it is impossible to be well pleasing to Him, for he who comes forward to God must believe that He is and that He is a rewarder of those who diligently seek Him.</li>
                 <br></br>

              <li><strong>Day 6</strong></li>
                 <li><strong>Hebrews 4:2</strong> For indeed we have had the good news announced to us, even as they also; but the word heard did not profit them, not being mixed together with faith in those who heard.</li>
                 <li><strong>2 Timothy 2:22</strong> But flee youthful lusts, and pursue righteousness, faith, love, peace with those who call on the Lord out of a pure heart.</li>
              </ul>
           </Card.Body>
        </Accordion.Collapse>
      </Card>

      {/* Daily verses for Week 33 */}
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="33">
           Week 33: The Vision, Experience, Enjoyment, and Expression of the Supreme Preciousness of Christ for the Genuine Church Life
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="33">   
           <Card.Body>
           <ul>
              <li><strong>Day 1</strong></li>
                 <li><strong>Psalm 118:22</strong> The stone which the builders rejected / Has become the head of the corner.</li>
                 <li><strong>1 Peter 2:4</strong> Coming to Him, a living stone, rejected by men but with God chosen and precious,</li>
                 <br></br>

              <li><strong>Day 2</strong></li>
                 <li><strong>Matthew 10:37-38</strong> He who loves father or mother above Me is not worthy of Me; and he who loves son or daughter above Me is not worthy of Me. And he who does not take his cross and follow after Me is not worthy of Me.</li>
                 <li><strong>Jeremiah 15:19</strong> Therefore thus says Jehovah, If you return, I will restore you; / You will stand before Me; / And if you bring out the precious from the worthless, / You will be as My mouth; / They will turn to you, / But you will not turn to them.</li>
                 <br></br>

              <li><strong>Day 3</strong></li>
                 <li><strong>Mark 16:7</strong> But go, tell His disciples and Peter that He is going before you into Galilee. There you will see Him, even as He told you.</li>
                 <li><strong>2 Peter 1:16</strong> For we did not follow cleverly devised myths when we made known to you the power and coming of our Lord Jesus Christ, but we became eyewitnesses of that One's majesty.</li>
                 <br></br>

              <li><strong>Day 4</strong></li>
                 <li><strong>Isaiah 6:1</strong> In the year that King Uzziah died I saw the Lord sitting on a high and lofty throne, and the train of His robe filled the temple.</li>
                 <li><strong>Isaiah 6:5</strong> Then I said, Woe is me, for I am finished! For I am a man of unclean lips, / And in the midst of a people of unclean lips I dwell; / Yet my eyes have seen the King, Jehovah of hosts.</li>
                 <li><strong>John 12:41</strong> These things said Isaiah because he saw His glory and spoke concerning Him.</li>
                 <br></br>

              <li><strong>Day 5</strong></li>
                 <li><strong>Isaiah 6:4-5</strong><br></br>
                 <strong><sup>[4]</sup></strong>And the foundations of the threshold shook at the voice of him who called, and the house was filled with smoke.<br></br>
                 <strong><sup>[5]</sup></strong>Then I said, Woe is me, for I am finished! For I am a man of unclean lips, / And in the midst of a people of unclean lips I dwell; / Yet my eyes have seen the King, Jehovah of hosts.</li>
                 <br></br>

              <li><strong>Day 6</strong></li>
                 <li><strong>Daniel 10:5-6</strong><br></br>
                 <strong><sup>[5]</sup></strong>I lifted up my eyes and looked, and there was a certain man clothed in linen, whose loins were girded with gold of Uphaz.<br></br>
                 <strong><sup>[6]</sup></strong>His body also was like beryl, His face like the appearance of lightning, His eyes like torches of fire, His arms and His feet like the gleam of polished bronze, and the sound of His words like the sound of a multitude.</li>
              </ul>
           </Card.Body>
        </Accordion.Collapse>
      </Card>

      {/* Daily verses for Week 34 */}
      <Card>
      <Accordion.Toggle as={Card.Header} eventKey="34">
          Week 34: Shepherding according to God
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="34">
           <Card.Body>
           <ul>
              <li><strong>Day 1</strong></li>
                 <li><strong>John 21:15-17</strong><br></br>
                 <strong><sup>[15]</sup></strong>Then when they had eaten breakfast, Jesus said to Simon Peter, Simon, son of John, do you love Me more than these? He said to Him, Yes, Lord, You know that I love You. He said to him, Feed My lambs.<br></br>
                 <strong><sup>[16]</sup></strong>He said to him again a second time, Simon, son of John, do you love Me? He said to Him, Yes, Lord, You know that I love You. He said to him, Shepherd My sheep.<br></br>
                 <strong><sup>[17]</sup></strong>He said to him the third time, Simon, son of John, do you love Me? Peter was grieved that He said to him the third time, Do you love Me? and he said to Him, Lord, You know all things; You know that I love You. Jesus said to him, Feed My sheep.</li>
                 <br></br>

              <li><strong>Day 2</strong></li>
                 <li><strong>1 Peter 5:2-4</strong><br></br>
                 <strong><sup>[2]</sup></strong>Shepherd the flock of God among you, overseeing not under compulsion but willingly, according to God; not by seeking gain through base means but eagerly;<br></br>
                 <strong><sup>[3]</sup></strong>Nor as lording it over your allotments but by becoming patterns of the flock.<br></br>
                 <strong><sup>[4]</sup></strong>And when the Chief Shepherd is manifested, you will receive the unfading crown of glory.</li>
                 <br></br>

              <li><strong>Day 3</strong></li>
                 <li><strong>1 Corinthians 12:23-25</strong><br></br>
                 <strong><sup>[23]</sup></strong>And those members of the body which we consider to be less honorable, these we clothe with more abundant honor; and our uncomely members come to have more abundant comeliness,<br></br>
                 <strong><sup>[24]</sup></strong>But our comely members have no need. But God has blended the body together, giving more abundant honor to the member that lacked,<br></br>
                 <strong><sup>[25]</sup></strong>That there would be no division in the body, but that the members would have the same care for one another.</li>
                 <br></br>

              <li><strong>Day 4</strong></li>
                 <li><strong>John 10:11</strong> I am the good Shepherd; the good Shepherd lays down His life for the sheep.</li>
                 <li><strong>1 Peter 2:25</strong> For you were like sheep being led astray, but you have now returned to the Shepherd and Overseer of your souls.</li>
                 <br></br>

              <li><strong>Day 5</strong></li>
                 <li><strong>Hebrews 13:20-21</strong><br></br>
                 <strong><sup>[20]</sup></strong>Now the God of peace, He who brought up from the dead our Lord Jesus, the great Shepherd of the sheep, in the blood of an eternal covenant,<br></br>
                 <strong><sup>[21]</sup></strong>Perfect you in every good work for the doing of His will, doing in us that which is well pleasing in His sight through Jesus Christ; to Him be the glory forever and ever. Amen.</li>
                 <li><strong>1 Peter 5:4</strong> And when the Chief Shepherd is manifested, you will receive the unfading crown of glory.</li>
                 <br></br>

              <li><strong>Day 6</strong></li>
                 <li><strong>1 Peter 5:2</strong> Shepherd the flock of God among you, overseeing not under compulsion but willingly, according to God; not by seeking gain through base means but eagerly.</li>
                 <li><strong>2 Peter 1:4</strong> Through which He has granted to us precious and exceedingly great promises that through these you might become partakers of the divine nature, having escaped the corruption which is in the world by lust.</li>
              </ul>
           </Card.Body>
        </Accordion.Collapse>
      </Card>

      {/* Daily verses for Week 35 */}
      <Card>
      <Accordion.Toggle as={Card.Header} eventKey="35"> 
         Week 35: The Fellowship of the Eternal Life—the Reality of Living in the Body of Christ
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="35">
           <Card.Body>
           <ul>
              <li><strong>Day 1</strong></li>
                 <li><strong>1 John 1:3</strong> That which we have seen and heard we report also to you that you also may have fellowship with us, and indeed our fellowship is with the Father and with His Son Jesus Christ.</li>
                 <li><strong>Revelation 22:1</strong> And he showed me a river of water of life, bright as crystal, proceeding out of the throne of God and of the Lamb in the middle of its street.</li>
                 <br></br>

              <li><strong>Day 2</strong></li>
                 <li><strong>1 John 1:6-7</strong><br></br>
                 <strong><sup>[6]</sup></strong>If we say that we have fellowship with Him and yet walk in the darkness, we lie and are not practicing the truth;<br></br>
                 <strong><sup>[7]</sup></strong>But if we walk in the light as He is in the light, we have fellowship with one another, and the blood of Jesus His Son cleanses us from every sin.</li>
                 <li><strong>Acts 2:42</strong> And they continued steadfastly in the teaching and the fellowship of the apostles, in the breaking of bread and the prayers.</li>
                 <br></br>

              <li><strong>Day 3</strong></li>
                 <li><strong>2 Corinthians 13:14</strong> The grace of the Lord Jesus Christ and the love of God and the fellowship of the Holy Spirit be with you all.</li>
                 <li><strong>Philippians 2:1</strong> If there is therefore any encouragement in Christ, if any consolation of love, if any fellowship of spirit, if any tenderheartedness and compassions,</li>
                 <li><strong>1 Corinthians 10:16</strong> The cup of blessing which we bless, is it not the fellowship of the blood of Christ? The bread which we break, is it not the fellowship of the body of Christ?</li>
                 <br></br>

              <li><strong>Day 4</strong></li>
                 <li><strong>John 1:29</strong> The next day he saw Jesus coming to him and said, Behold, the Lamb of God, who takes away the sin of the world!</li>
                 <li><strong>Romans 8:2-3</strong><br></br>
                 <strong><sup>[2]</sup></strong>For the law of the Spirit of life has freed me in Christ Jesus from the law of sin and of death.<br></br>
                 <strong><sup>[3]</sup></strong>For that which the law could not do, in that it was weak through the flesh, God, sending His own Son in the likeness of the flesh of sin and concerning sin, condemned sin in the flesh,</li>
                 <br></br>

              <li><strong>Day 5</strong></li>
                 <li><strong>Genesis 1:26</strong> And God said, Let Us make man in Our image, according to Our likeness; and let them have dominion over the fish of the sea and over the birds of heaven and over the cattle and over all the earth and over every creeping thing that creeps upon the earth.</li>
                 <li><strong>Isaiah 43:7</strong> Everyone who is called by My name, / Whom I have created for My glory, / Whom I have formed, indeed, whom I have made.</li>
                 <li><strong>Romans 3:23</strong> For all have sinned and fall short of the glory of God.</li>
                 <br></br>

              <li><strong>Day 6</strong></li>
                 <li><strong>1 John 1:9</strong> If we confess our sins, He is faithful and righteous to forgive us our sins and cleanse us from all unrighteousness.</li>
                 <li><strong>1 John 2:1</strong> My little children, these things I write to you that you may not sin. And if anyone sins, we have an Advocate with the Father, Jesus Christ the Righteous.</li>
              </ul>
           </Card.Body>
        </Accordion.Collapse>
      </Card>

      {/* Daily verses for Week 36 */}
      <Card>
      <Accordion.Toggle as={Card.Header} div className="card text-white bg-info" eventKey="36">
         <span style={{fontWeight: `bold`}}>Week 36: The True One</span>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="36">
           <Card.Body>
           <ul>
              <li><strong>Day 1</strong></li>
                 <li><strong>1 John 2:27</strong> And as for you, the anointing which you have received from Him abides in you, and you have no need that anyone teach you; but as His anointing teaches you concerning all things and is true and is not a lie, and even as it has taught you, abide in Him.</li>
                 <li><strong>1 John 4:4</strong> You are of God, little children; and you have overcome them because greater is He who is in you than he who is in the world.</li>
                 <br></br>

              <li><strong>Day 2</strong></li>
                 <li><strong>1 John 3:1</strong> Behold what manner of love the Father has given to us, that we should be called children of God; and we are. Because of this the world does not know us, because it did not know Him.</li>
                 <li><strong>1 John 4:13-14</strong><br></br>
                 <strong><sup>[13]</sup></strong>In this we know that we abide in Him and He in us, that He has given to us of His Spirit.<br></br>
                 <strong><sup>[14]</sup></strong>And we have beheld and testify that the Father has sent the Son as the Savior of the world.</li>
                 <br></br>

              <li><strong>Day 3</strong></li>
                 <li><strong>1 John 5:2</strong> In this we know that we love the children of God, when we love God and do His commandments.</li>
                 <li><strong>John 16:13</strong> But when He, the Spirit of reality, comes, He will guide you into all the reality; for He will not speak from Himself, but what He hears He will speak; and He will declare to you the things that are coming.</li>
                 <br></br>

              <li><strong>Day 4</strong></li>
                 <li><strong>John 1:14</strong> And the Word became flesh and tabernacled among us (and we beheld His glory, glory as of the only Begotten from the Father), full of grace and reality.</li>
                 <li><strong>1 John 4:15</strong> Whoever confesses that Jesus is the Son of God, God abides in him and he in God.</li>
                 <br></br>

              <li><strong>Day 5</strong></li>
                 <li><strong>Colossians 2:9</strong> For in Him dwells all the fullness of the Godhead bodily.</li>
                 <li><strong>1 John 3:24</strong> And he who keeps His commandments abides in Him, and He in him. And in this we know that He abides in us, by the Spirit whom He gave to us.</li>
                 <br></br>

              <li><strong>Day 6</strong></li>
                 <li><strong>1 John 4:16</strong> And we know and have believed the love which God has in us. God is love, and he who abides in love abides in God and God abides in him.</li>
                 <li><strong>1 John 5:11-12</strong><br></br>
                 <strong><sup>[11]</sup></strong>And this is the testimony, that God gave to us eternal life and this life is in His Son.<br></br>
                 <strong><sup>[12]</sup></strong>He who has the Son has the life; he who does not have the Son of God does not have the life.</li>
              </ul>
           </Card.Body>
        </Accordion.Collapse>
      </Card>
      </Accordion>
     <h2 className="title"></h2><br></br>
      <br></br>
      <p><strong><u>Resources:</u></strong></p> 
      <ul>
         {/* Message */}
         <li>All verses are quoted from the <a href="https://www.recoveryversion.bible/" target="_blank" rel="noopener noreferrer">Holy Bible Recovery Version</a>.</li>
         <li>You can order a free copy of the New Testament Recovery Version <a href="http://biblesforamerica.org/free-bible/" target="_blank" rel="noopener noreferrer">here.</a></li>
      </ul>
    </div>
    </section>
  </Layout>
)

export default IndexPage
